export default __webpack_public_path__ + "static/media/camera-logo.dfbf7d7a.jpg";